module.exports = __webpack_public_path__ + "img/1.81e0fb14.jpeg";